import React,{useContext} from "react";
import themeContext from "../../context/theme/ThemeContext";

const EyeIcon = (props) => {
  const {themeName,theme} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
    >
      <path
        d="M7 1.2C9.41182 1.2 11.5627 2.478 12.6127 4.5C11.5627 6.522 9.41182 7.8 7 7.8C4.58818 7.8 2.43727 6.522 1.38727 4.5C2.43727 2.478 4.58818 1.2 7 1.2ZM7 0C3.81818 0 1.10091 1.866 0 4.5C1.10091 7.134 3.81818 9 7 9C10.1818 9 12.8991 7.134 14 4.5C12.8991 1.866 10.1818 0 7 0ZM7 3C7.87818 3 8.59091 3.672 8.59091 4.5C8.59091 5.328 7.87818 6 7 6C6.12182 6 5.40909 5.328 5.40909 4.5C5.40909 3.672 6.12182 3 7 3ZM7 1.8C5.42182 1.8 4.13636 3.012 4.13636 4.5C4.13636 5.988 5.42182 7.2 7 7.2C8.57818 7.2 9.86364 5.988 9.86364 4.5C9.86364 3.012 8.57818 1.8 7 1.8Z"
        fill={theme.palette.inactiveTool}

      />
    </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="16"
    //   height="16"
    //   viewBox="0 0 16 16"
    //   fill="none"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M0.666992 8C1.82033 5.07333 4.66699 3 8.00033 3C11.3337 3 14.1803 5.07333 15.3337 8C14.1803 10.9267 11.3337 13 8.00033 13C4.66699 13 1.82033 10.9267 0.666992 8ZM13.8803 8C12.7803 5.75333 10.527 4.33333 8.00033 4.33333C5.47366 4.33333 3.22033 5.75333 2.12033 8C3.22033 10.2467 5.47366 11.6667 8.00033 11.6667C10.527 11.6667 12.7803 10.2467 13.8803 8ZM8.00033 6.33333C8.92033 6.33333 9.66699 7.08 9.66699 8C9.66699 8.92 8.92033 9.66667 8.00033 9.66667C7.08033 9.66667 6.33366 8.92 6.33366 8C6.33366 7.08 7.08033 6.33333 8.00033 6.33333ZM5.00033 8C5.00033 6.34667 6.34699 5 8.00033 5C9.65366 5 11.0003 6.34667 11.0003 8C11.0003 9.65333 9.65366 11 8.00033 11C6.34699 11 5.00033 9.65333 5.00033 8Z"
    //     fill="#EDEDED"
    //   />
    // </svg>
  );
};

export default EyeIcon;
